export const langSessions = {
  fr: {
    sessions: 'Sessions',
    toStats: 'Voir les détails',
    sourceFile: 'Fichier source : ',
    modalHead: 'Modifier session',
    modalTitle: 'Titre',
    modalComments: 'Commentaires',
    modalSave: 'Actualiser',
    modalCancel: 'Annuler',
    help: [
      `Cliquez sur une session dans la liste pour visualiser sa localisation et afficher le bouton 'Voir détails'`,
      `Cliquez sur 'Ajouter' pour sélectionner un fichier .gpx ou .fit et l'ajouter aux sessions enregistrées`,
      `Cliquez sur 'Modifier' pour changer le titre de la session ou ajouter des commentaires. Par défaut, le titre de la session est identique au nom du fichier gpx ou fit utilisé à l'ajout de la session.`,
      `Cliquez sur 'Supprimer' pour supprimer une session et toutes ses données (ne peut pas être annulé)`,
    ],
    registeredOnly: 'Réservé aux utilisateurs enregistrés',
    minTitleNbChar: `3 caractères min.`,
  },
  eng: {
    sessions: 'Sessions',
    toStats: 'View details',
    sourceFile: 'Source file : ',
    modalHead: 'Edit session',
    modalTitle: 'Title',
    modalComments: 'Comments',
    modalSave: 'Update',
    modalCancel: 'Cancel',
    help: [
      `Click on a session in the list to view its location and display the 'View details' button`,
      `Click 'Add' to select a .gpx or .fit file and add it to the saved sessions`,
      `Click 'Edit' to change session title or add comments. By default, the title of the session is identical to the name of the gpx or fit file used when adding the session.`,
      `Click 'Delete' to delete a session and all its data (cannot be undone)`,
    ],
    registeredOnly: 'Registered users only',
    minTitleNbChar: `3 characters min.`,
  },
}
